export function extractNewWords(
  delta: string,
  isStreamComplete: boolean
): { completeWords: string[]; bufferedPartial: string } {
  const tokens = delta.split(/\s+/).filter(Boolean);

  if (tokens.length === 0) {
    return { completeWords: [], bufferedPartial: '' };
  }

  if (isStreamComplete || /\s$/.test(delta)) {
    return { completeWords: tokens, bufferedPartial: '' };
  }

  const bufferedPartial = tokens.pop()!;
  return { completeWords: tokens, bufferedPartial };
}

export function wrapWordsWithAnimation(words: string[]): string {
  if (words.length === 0) return '';
  return words
    .map((word) => `<span class='caddie-fade-in'>${word}</span> `)
    .join('');
}

export function buildDisplayText(text: string): string {
  return text;
}
